import { AccountBalance } from '@mui/icons-material';
import BarChartIcon from '@mui/icons-material/BarChart';
import CardMembershipIcon from '@mui/icons-material/CardMembership';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import HomeIcon from '@mui/icons-material/Home';
import ReceiptIcon from '@mui/icons-material/Receipt';
import SettingsIcon from '@mui/icons-material/Settings';
import React from 'react';

export const buttonsAvailable: {
  [key: string]: {
    label: string;
    id: string;
    icon: React.ReactNode;
  };
} = {
  home: {
    label: 'Inicio',
    id: 'home',
    icon: <HomeIcon style={{ fontSize: '19px' }} />,
  },
  factoring: {
    label: 'Factoring',
    id: 'factoring/creditLine',
    icon: <ReceiptIcon style={{ fontSize: '19px' }} />,
  },
  sgr: {
    label: 'Garantías',
    id: 'sgr',
    icon: <CardMembershipIcon style={{ fontSize: '19px' }} />,
  },
  credit: {
    label: 'Crédito',
    id: 'credit',
    icon: <CreditCardIcon style={{ fontSize: '19px' }} />,
  },
  report: {
    label: 'Reportes',
    id: 'report',
    icon: <BarChartIcon style={{ fontSize: '19px' }} />,
  },
  billing: {
    label: 'Facturación',
    id: 'billing',
    icon: <AccountBalance style={{ fontSize: '19px' }} />,
  },
  settings: {
    label: 'Configuración',
    id: 'settings',
    icon: <SettingsIcon style={{ fontSize: '19px' }} />,
  },
};
